import '/assets/styles/main.pcss';

import LazyLoad from 'vanilla-lazyload';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'

import 'glightbox/src/postcss/glightbox.css';

import hamburger from './components/hamburger';
import header from './components/header';
import product from './components/product';
import search from './components/search';
import slideToggle from './components/slide-toggle';
import carousel from './components/carousel';
import navSelect from './components/nav-select';
import articlesList from './components/articles-list';
import anchorNav from './components/anchor-nav';
import productFilters from './components/product-filters';
import searchBar from './components/search-bar';
import careers from './components/careers';
import innovation from './components/innovation';
import dropdown from './components/dropdown';
import newsletter from './components/newsletter';
import customErrorMessages from './components/custom-error-messages';
import gtm from './components/gtm';
import sampleOrderForm from './components/sample-order-form';
import inspirationSelector from './components/inspirationSelector';
import contactForm from './components/contactForm';

Alpine.plugin(collapse)

window.Alpine = Alpine;

Alpine.data('searchController', (applicationIds, currency, searchQuery, showApplications, productType) => search(applicationIds, currency, searchQuery, showApplications, productType));
Alpine.data('articlesListController', (categoryId) => articlesList(categoryId));
Alpine.data('careersController', () => careers());

Alpine.data('inspirationSelectorController', inspirationSelector);
Alpine.data('contactFormController', contactForm);

Alpine.start();

hamburger();
header();
product();
slideToggle();
carousel();
navSelect();
anchorNav();
productFilters();
searchBar();
careers();
innovation();
dropdown();
newsletter();
customErrorMessages();
sampleOrderForm();


if (import.meta.env.MODE != 'development') {
  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(function () {
    console.log('Didomi on ready gtm');
    gtm();
  });
}


window.lazyloadInstance = new LazyLoad({
  cancel_on_exit: false // https://github.com/verlok/vanilla-lazyload/issues/496
});


